import Empty from '../empty';
import useConfigInject from '../_util/hooks/useConfigInject';
const RenderEmpty = (props) => {
    const { prefixCls } = useConfigInject('empty', props);
    const renderHtml = (componentName) => {
        // const choices: Record<EmptyDesignType, string> = {
        //   view: '88px',
        //   module: '58px',
        //   text: undefined,
        // };
        // let tableStyle;
        // if (props.type === 'view') {
        //   tableStyle = {
        //     paddingBottom: '180px',
        //   };
        // }
        switch (componentName) {
            case 'Table':
            case 'List':
                return (<Empty mode={props.mode} type={props.type} scene={props.scene} description={props.desc}/>);
            case 'Select':
            case 'TreeSelect':
            case 'Cascader':
            case 'Transfer':
            case 'Mentions':
                return <Empty mode={props.mode} noImage class={`${prefixCls.value}-small`}/>;
            default:
                return <Empty mode={props.mode}/>;
        }
    };
    return renderHtml(props.componentName);
};
function renderEmpty(componentName, mode, type, scene, desc) {
    return (<RenderEmpty componentName={componentName} mode={mode} type={type} scene={scene} desc={desc}/>);
}
export default renderEmpty;
